import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(null);
  const [hasSelectedLanguage, setHasSelectedLanguage] = useState(false);

  // Check localStorage on mount - but always show invitation card
  useEffect(() => {
    const savedLanguage = localStorage.getItem('wedding-language');
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'bn')) {
      // Only set the language state, but don't skip the invitation card
      setLanguageState(savedLanguage);
      // Don't set hasSelectedLanguage to true - always show card
    }
  }, []);

  const setLanguage = (lang) => {
    setLanguageState(lang);
    setHasSelectedLanguage(true);
    localStorage.setItem('wedding-language', lang);
  };

  // Translation helper function
  const t = (key) => {
    const translation = translations[key];
    if (!translation) {
      return key;
    }
    return translation[language] || translation.en;
  };

  // For array translations
  const tArray = (key) => {
    const translation = translations[key];
    if (!translation) {
      return [];
    }
    return translation[language] || translation.en;
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      hasSelectedLanguage,
      t,
      tArray,
      isBangla: language === 'bn'
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
